export const DEFAULT_VAT_PERCENTAGE = 1900; // 19.00%
export const DEFAULT_PAYMENT_TARGET_DAYS = 30; // Default payment target days for invoices